import { defineMessages } from "react-intl"

export default defineMessages({
  difficulties: {
    id: "app.components.DifficultyLevel.difficulties",
  },
  "difficulties.Easy": {
    id: "app.components.DifficultyLevel.difficulties.Easy",
  },
  "difficulties.Normal": {
    id: "app.components.DifficultyLevel.difficulties.Normal",
  },
  "difficulties.Hard": {
    id: "app.components.DifficultyLevel.difficulties.Hard",
  },
  "difficulties.Nightmare": {
    id: "app.components.DifficultyLevel.difficulties.Nightmare",
  },
})
